import React, { useEffect, useState } from 'react';
import Header from '../layouts/Header';
import Footer from '../layouts/Footer';
import { Badge, Button, Card, Col, Form, Row, Table } from 'react-bootstrap';
import axiosInstance from '../services/axiosInterceptor';

const emptyForm = { activityId: null, activityName: '', defaultPoints: 3, isActive: 1 };

export default function DisciplineMeritActivities() {
  const setSkin = useState(localStorage.getItem('skin-mode') ? 'dark' : '')[1];
  const [activities, setActivities] = useState([]);
  const [form, setForm] = useState(emptyForm);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const fetchActivities = () => {
    axiosInstance.get('/api/discipline/conduct-activities?includeInactive=1')
      .then(res => setActivities(res.data || []))
      .catch(() => setError('ไม่สามารถโหลดรายการงานจิตอาสาได้'));
  };

  useEffect(fetchActivities, []);

  const submit = (e) => {
    e.preventDefault();
    setSaving(true);
    setError('');
    const payload = {
      activityId: form.activityId,
      activityName: form.activityName.trim(),
      defaultPoints: Number(form.defaultPoints),
      isActive: Number(form.isActive)
    };
    const request = form.activityId
      ? axiosInstance.put('/api/discipline/conduct-activities', payload)
      : axiosInstance.post('/api/discipline/conduct-activities', payload);

    request
      .then(() => {
        setForm(emptyForm);
        fetchActivities();
      })
      .catch(err => setError(err.response?.data?.message || 'ไม่สามารถบันทึกได้'))
      .finally(() => setSaving(false));
  };

  const edit = (activity) => {
    setForm({
      activityId: activity.activity_id,
      activityName: activity.activity_name,
      defaultPoints: activity.default_points,
      isActive: activity.is_active
    });
  };

  return (
    <>
      <Header onSkin={setSkin} />
      <div className="main main-app p-3 p-lg-4">
        <div className="mb-4">
          <ol className="breadcrumb fs-sm mb-1">
            <li className="breadcrumb-item">ฝ่ายปกครอง</li>
            <li className="breadcrumb-item active">รายการงานจิตอาสา</li>
          </ol>
          <h4 className="main-title mb-0">จัดการรายการงานจิตอาสา</h4>
        </div>

        {error && <div className="alert alert-danger">{error}</div>}

        <Row className="g-3">
          <Col lg={4}>
            <Card className="card-one">
              <Card.Header>
                <Card.Title as="h6" className="mb-0">{form.activityId ? 'แก้ไขรายการ' : 'เพิ่มรายการใหม่'}</Card.Title>
              </Card.Header>
              <Card.Body>
                <Form onSubmit={submit}>
                  <Form.Group className="mb-3">
                    <Form.Label>ชื่องานจิตอาสา</Form.Label>
                    <Form.Control
                      value={form.activityName}
                      onChange={e => setForm({ ...form, activityName: e.target.value })}
                      placeholder="เช่น ทำความสะอาดอาคารเรียน"
                      required
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>คะแนนที่เพิ่มเริ่มต้น</Form.Label>
                    <Form.Control
                      type="number"
                      min="1"
                      max="100"
                      value={form.defaultPoints}
                      onChange={e => setForm({ ...form, defaultPoints: e.target.value })}
                      required
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>สถานะ</Form.Label>
                    <Form.Select value={form.isActive} onChange={e => setForm({ ...form, isActive: e.target.value })}>
                      <option value={1}>ใช้งาน</option>
                      <option value={0}>ปิดใช้งาน</option>
                    </Form.Select>
                  </Form.Group>
                  <div className="d-flex gap-2">
                    <Button type="submit" disabled={saving}>
                      {saving ? 'กำลังบันทึก' : 'บันทึก'}
                    </Button>
                    {form.activityId && (
                      <Button variant="outline-secondary" type="button" onClick={() => setForm(emptyForm)}>
                        ยกเลิก
                      </Button>
                    )}
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </Col>
          <Col lg={8}>
            <Card className="card-one">
              <Card.Header>
                <Card.Title as="h6" className="mb-0">Master list</Card.Title>
              </Card.Header>
              <Card.Body className="p-0">
                <Table responsive hover className="mb-0">
                  <thead className="table-secondary">
                    <tr>
                      <th>งานจิตอาสา</th>
                      <th className="text-center" style={{ width: 140 }}>คะแนนที่เพิ่ม</th>
                      <th className="text-center" style={{ width: 120 }}>สถานะ</th>
                      <th className="text-center" style={{ width: 110 }}></th>
                    </tr>
                  </thead>
                  <tbody>
                    {activities.map(activity => (
                      <tr key={activity.activity_id}>
                        <td>{activity.activity_name}</td>
                        <td className="text-center fw-semibold text-success">+{activity.default_points}</td>
                        <td className="text-center">
                          {Number(activity.is_active)
                            ? <Badge bg="success">ใช้งาน</Badge>
                            : <Badge bg="secondary">ปิดใช้งาน</Badge>}
                        </td>
                        <td className="text-center">
                          <Button variant="outline-primary" size="sm" onClick={() => edit(activity)}>
                            แก้ไข
                          </Button>
                        </td>
                      </tr>
                    ))}
                    {activities.length === 0 && (
                      <tr><td colSpan={4} className="text-center text-secondary py-4">ยังไม่มีรายการงานจิตอาสา</td></tr>
                    )}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Footer />
      </div>
    </>
  );
}
